import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import {
  handleTabErrors,
  setQuestionModalDetails,
} from "../../../../Redux/reducers/questionTranslationSlice";
import { QuestionLabelMap, choice_types } from "../../questionTypes";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Modal,
  SxProps,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { a11yProps, ModalTabPanel } from "../../../Common/UI/TabPanel";
import {
  ModalDrawerButtonStyles,
  ModalDrawerStyles,
  ModalHeaderTitleStyles,
} from "../../../Common/styles/modal";
import ChoiceTab from "./ChoiceTab";
import { BasicTab } from "./BasicTab";
import { saveQuestion } from "../../../../Redux/actions/questionTranslationAction";
import { submitValidation } from "./utils";
import { SummaryTab } from "./SummaryTab";

export enum ValidationTypes {
  error = "error",
  warning = "warning",
  info = "info",
}

const QuestionPropertiesModal: React.FC = () => {
  const dispatch = useAppDispatch();

  const isLoading = useAppSelector(
    ({ questionTranslation }) => questionTranslation.loading,
  );
  const editable = useAppSelector(
    ({ questionTranslation }) => questionTranslation.editable,
  );

  const currentQuestion = useAppSelector(
    ({ questionTranslation }) => questionTranslation.modalQuestion,
  );

  const isBasicError = useAppSelector(
    ({ questionTranslation }) => questionTranslation.isBasicError,
  );
  const isChoicesError = useAppSelector(
    ({ questionTranslation }) => questionTranslation.isChoicesError,
  );
  const isSummaryError = useAppSelector(
    ({ questionTranslation }) => questionTranslation.isSummaryError,
  );

  // const isRepeatedConfigError = useAppSelector(
  //   ({ questionTranslation }) => questionTranslation.isRepeatedConfigError
  // );
  // const isGridConfigError = useAppSelector(
  //   ({ questionTranslation }) => questionTranslation.isGridConfigError
  // );
  // const isValidationsError = useAppSelector(
  //   ({ questionTranslation }) => questionTranslation.isValidationsError
  // );

  const [tabIndex, setTabIndex] = useState("basic");
  // const [noLocalTabError, setNoLocalTabError] = useState(true);

  let indicatorColor = "primary.main";
  if (tabIndex === "basic" && isBasicError) {
    indicatorColor = "error.main";
  } else if (tabIndex === "choices" && isChoicesError) {
    indicatorColor = "error.main";
  } else {
    indicatorColor = "primary.main";
  }
  // else if (tabIndex === "validations" && isValidationsError) {
  //   indicatorColor = "error.main";
  // }

  const closeModal = () => {
    dispatch(
      setQuestionModalDetails({
        show: false,
        question: null,
      }),
    );
    dispatch(
      handleTabErrors({
        errorHandler: {
          basic: "",
          choices: "",
          repeatedConfig: "",
          gridConfig: "",
          validations: "",
          summary: "",
        },
      }),
    );
  };

  const submitHandler = () => {
    const { errorHandler } = submitValidation(currentQuestion);
    dispatch(handleTabErrors({ errorHandler: errorHandler }));

    if (errorHandler.ok) {
      dispatch(saveQuestion());
    }
  };

  const changetabIndex = (_: any, oldValue: string) => {
    setTabIndex(oldValue);
  };

  const getTabSx = (isError: boolean): SxProps => ({
    textTransform: "capitalize",
    color: isError ? "error.main" : "primary.main",
    "&.Mui-selected": {
      color: isError ? "error.main" : "primary.main",
    },
  });

  return (
    <Modal open={true}>
      <Box sx={ModalDrawerStyles}>
        <Typography sx={ModalHeaderTitleStyles} mb={1}>
          {currentQuestion
            ? QuestionLabelMap[currentQuestion.type]
            : "Question"}
        </Typography>
        <Box sx={{ borderBottom: 1, borderBottomColor: "#E5E7EB" }}>
          <Tabs
            value={tabIndex}
            onChange={changetabIndex}
            aria-label="Modal Settings"
            sx={{
              "& .MuiTabs-indicator": {
                backgroundColor: indicatorColor,
              },
            }}
          >
            <Tab
              label="Basic"
              value="basic"
              {...a11yProps(0)}
              sx={getTabSx(!!isBasicError)}
            />

            {choice_types.includes(currentQuestion.type) && (
              <Tab
                label="Choices"
                value="choices"
                {...a11yProps(2)}
                sx={getTabSx(!!isChoicesError)}
              />
            )}

            <Tab
              label="Summary Translation"
              value="summary"
              {...a11yProps(3)}
              sx={getTabSx(!!isSummaryError)}
            />
          </Tabs>
        </Box>
        <ModalTabPanel value={tabIndex} index={"basic"}>
          <BasicTab question={currentQuestion} />
        </ModalTabPanel>
        <ModalTabPanel value={tabIndex} index={"choices"}>
          <ChoiceTab question={currentQuestion} />
        </ModalTabPanel>
        <ModalTabPanel value={tabIndex} index={"summary"}>
          <SummaryTab question={currentQuestion} />
        </ModalTabPanel>

        <Box sx={{ mt: "auto" }}>
          <Divider />
          <Box sx={ModalDrawerButtonStyles}>
            <Button
              variant="outlined"
              onClick={closeModal}
              disabled={isLoading}
            >
              {editable ? "Cancel" : "Close"}
            </Button>
            {editable && (
              <Button
                variant="contained"
                onClick={submitHandler}
                sx={{ ml: 2 }}
                disabled={isLoading}
                // disabled={isLoading || !noLocalTabError}
              >
                {isLoading ? <CircularProgress size={24} /> : "Save"}
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default QuestionPropertiesModal;
